<template lang="pug">
#chiarman_detail
  about-us-header(:aboutUsCommon="aboutUsCommon")
  section.container.i_mb_10
    .row.i_mt_14.i_mt_md_10
      .col-12.text-center
        h2.title {{ shareholderMeeting.Title }}
    .row
      .col-12
        .info.d-flex.i_mt_8(v-for="info in currentList")
          .left.text-center
            h5 {{ info.MeetingTitle }}
            p.i_body_l {{ info.MeetingSubTitle }}
          .right
            a.item.d-flex.align-items-center(
              :href="item.FileURL",
              v-for="item in info.MeetingFileList"
            )
              svg-icon(iconClass="ic_download", className="icon")
              p.i_body_l {{ item.FileName }}
    .row.i_mt_8
      .col-12.text.center.justify-content-center
        b-pagination(
          v-model="currentPage",
          :total-rows="totalRows",
          :per-page="perPage",
          first-number,
          last-number
        )
  custom-footer
</template>

<script>
import aboutUsHeader from "@/components/common/Header";
import CustomFooter from "@/components/common/Footer";
import { getAboutUsCommon, getShareholderMeeting } from "@/json/about_us";

export default {
  name: "ShareholderServicesDetail",
  metaInfo() {
    return {
      title: this.shareholderMeeting.SEO_Title,
      meta: [
        {
          name: "description",
          content: this.shareholderMeeting.SEO_Description,
        },
      ],
    };
  },
  components: {
    "about-us-header": aboutUsHeader,
    "custom-footer": CustomFooter,
  },
  data() {
    return {
      totalRows: 0,
      perPage: 5,
      currentPage: 1,

      aboutUsCommon: {},

      shareholderMeeting: {},

      currentList: [],
    };
  },
  watch: {
    currentPage() {
      this.getCurrentList();
    },
  },
  created() {
    this.getAboutUsCommon();
    this.getShareholderMeeting();
  },
  methods: {
    getAboutUsCommon() {
      getAboutUsCommon().then((response) => {
        this.aboutUsCommon = response.data;
      });
    },
    getShareholderMeeting() {
      getShareholderMeeting().then((response) => {
        this.shareholderMeeting = response.data;
        this.totalRows = response.data.ShareholderMeetingList.length;
        this.getCurrentList();
      });
    },
    getCurrentList() {
      this.currentList = [];
      let number = this.perPage * this.currentPage;
      this.currentList = this.shareholderMeeting.ShareholderMeetingList.slice(
        number - this.perPage,
        number
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/pagination";
@import "@/assets/style/about_us/shareholder_services";
</style>
